{
  "el": {
    "task": {
      "actions": {
        "create": "Εργασία",
        "create_and_send": "Δημιουργία και αποστολή",
        "delete": "Διαγραφή εργασίας",
        "keep_as_draft": "Διατήρηση ως πρόχειρη",
        "open_in_project": "Άνοιγμα εργασίας στο έργο",
        "remove_from_unit": "Αφαίρεση εργασίας από αυτό το ακίνητο",
        "save_as_draft": "Αποθήκευση ως πρόχειρη",
        "update": "Επεξεργασία εργασίας"
      },
      "attributes": {
        "assignments_count": "Αναθέσεις",
        "category": "Τρόπος ολοκλήρωσης",
        "created_at": "Δημιουργήθηκε",
        "description": "Περιγραφή",
        "phase": "Φάση",
        "title": "Τίτλος"
      },
      "categories": {
        "confirmation": "Επιβεβαίωση",
        "upload": "Ανέβασμα εγγράφου"
      },
      "categories_info": {
        "confirmation": "Ο υπεύθυνος την τσεκάρει όταν ολοκληρωθεί.",
        "upload": "Ο υπεύθυνος πρέπει να ανεβάσει ένα αρχείο για να την ολοκληρώσει."
      },
      "confirm": {
        "delete_accept": "Διαγραφή παντού",
        "delete_body": "Αυτό διαγράφει {count} εργασία σε {units}, ακόμη κι αν έχει ήδη ολοκληρωθεί. | Αυτό διαγράφει και τις {count} εργασίες σε {units}, μαζί με όσες έχουν ήδη ολοκληρωθεί.",
        "delete_body_empty": "Αυτό διαγράφει την εργασία.",
        "delete_body_project": "Αυτό διαγράφει την εργασία και τον υπεύθυνό της. | Αυτό διαγράφει την εργασία και όλους τους {count} υπευθύνους της.",
        "delete_cancel": "Διατήρηση εργασίας",
        "delete_header": "Διαγραφή «{title}»;",
        "delete_silent": "Δεν ειδοποιείται κανείς, και οι ειδοποιήσεις που έχουν ήδη σταλεί δεν ανακαλούνται.",
        "publish_body": "Δημιουργούμε {tasks} σε {units} και τις στέλνουμε στους υπευθύνους τους. Κάθε εργασία παίρνει την κατάσταση Ανοιχτή μέχρι να ολοκληρωθεί.",
        "publish_body_project": "Δημιουργούμε {tasks} σε αυτό το έργο και τις στέλνουμε στους υπευθύνους τους. Κάθε εργασία παίρνει την κατάσταση Ανοιχτή μέχρι να ολοκληρωθεί.",
        "publish_header": "Δημιουργία και αποστολή αυτής της εργασίας;",
        "publish_info": "Οι υπεύθυνοι λαμβάνουν αμέσως ένα email. Αποθήκευσέ την ως πρόχειρη αν δεν είσαι έτοιμος να τη στείλεις ακόμα.",
        "remove_from_unit_accept": "Αφαίρεση από το ακίνητο",
        "remove_from_unit_body": "Αυτό αφαιρεί όλους τους υπευθύνους αυτής της εργασίας σε αυτό το ακίνητο. Η εργασία και τα άλλα ακίνητά της μένουν ανέγγιχτα.",
        "remove_from_unit_customers": "Οι πελάτες αυτού του ακινήτου δεν τη βλέπουν πλέον στην πύλη τους.",
        "remove_from_unit_header": "Αφαίρεση «{title}» από αυτό το ακίνητο;"
      },
      "deep_link": {
        "show_all": "Εμφάνιση όλων των εργασιών",
        "single": "Βλέπεις μία εργασία."
      },
      "empty": {
        "filtered_description": "Δεν βρέθηκε τίποτα με τα φίλτρα που επέλεξες. Καθάρισέ τα για να δεις όλες τις εργασίες.",
        "filtered_description_project": "Δεν βρέθηκε τίποτα με τα φίλτρα που επέλεξες. Καθάρισέ τα για να δεις όλες τις εργασίες σε αυτό το έργο.",
        "filtered_title": "Καμία εργασία δεν ταιριάζει με τα φίλτρα σου",
        "none_description": "Δημιούργησε μια εργασία και ανάθεσέ τη στην ομάδα σου ή στους πελάτες ενός ή περισσότερων ακινήτων. Εμφανίζεται εδώ μόλις τη στείλεις.",
        "none_description_sup": "Δημιούργησε μια εργασία και ανάθεσέ τη στην ομάδα σου ή στους πελάτες σου. Εμφανίζεται εδώ μόλις τη στείλεις.",
        "none_title": "Καμία εργασία ακόμη"
      },
      "filters": {
        "phase_none": "Χωρίς φάση",
        "search": "Αναζήτηση εργασίας"
      },
      "form": {
        "category_title": "Πώς ολοκληρώνεται;",
        "description_help": "Ορατή σε όλους όσοι λαμβάνουν αυτή την εργασία.",
        "description_placeholder": "Πρόσθεσε λεπτομέρειες ή οδηγίες",
        "edit_info_assignments": "Τους υπευθύνους, τα ακίνητα και τις προθεσμίες τα διαχειρίζεσαι ανά υπεύθυνο στη λίστα εργασιών.",
        "edit_info_assignments_project": "Τους υπευθύνους και τις προθεσμίες τα διαχειρίζεσαι ανά υπεύθυνο στη λίστα εργασιών.",
        "edit_info_fields": "Τον τίτλο και την περιγραφή τα αλλάζεις εδώ.",
        "edit_info_fields_phase": "Τον τίτλο, την περιγραφή και τη φάση τα αλλάζεις εδώ.",
        "heading_create": "Νέα εργασία",
        "heading_update": "Επεξεργασία εργασίας",
        "phase_help_update": "Κάθε ακίνητο που έχει φτάσει στη νέα φάση ή την έχει ήδη ξεπεράσει βλέπει αυτή την εργασία αμέσως. Τα ακίνητα που δεν έχουν φτάσει ακόμα τη βλέπουν μόλις φτάσουν.",
        "phase_help_update_project": "Αν αυτό το έργο έχει φτάσει στη νέα φάση ή την έχει ήδη ξεπεράσει, οι υπεύθυνοι βλέπουν αυτή την εργασία αμέσως. Αλλιώς τη βλέπουν μόλις το έργο φτάσει εκεί.",
        "title_placeholder": "Τι πρέπει να γίνει;",
        "units_selected": "{selected} από {count} ακίνητο επιλεγμένα | {selected} από {count} ακίνητα επιλεγμένα",
        "units_title": "Ποια ακίνητα"
      },
      "labels": {
        "created_by": "Δημιουργήθηκε από {name} · {date}",
        "created_on": "Δημιουργήθηκε στις {date}",
        "required": "Αυτό το πεδίο είναι υποχρεωτικό",
        "set_all_assignees": "Ορισμός για τον υπεύθυνο | Ορισμός για όλους τους {count} υπευθύνους",
        "still_to_do": "{count} εκκρεμεί | {count} εκκρεμούν",
        "tasks_count": "{count} εργασία | {count} εργασίες",
        "units_count": "{count} ακίνητο | {count} ακίνητα",
        "units_required": "Επίλεξε τουλάχιστον ένα ακίνητο"
      },
      "toasts": {
        "create": "Η εργασία δημιουργήθηκε",
        "delete": "Η εργασία διαγράφηκε",
        "remove_from_unit": "Η εργασία αφαιρέθηκε από αυτό το ακίνητο",
        "update": "Η εργασία ενημερώθηκε"
      }
    }
  }
}
